<template>
  <div>
    <swiper
      :options="{
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: 0,
      }"
      class="swiper"
    >
      <swiper-slide :class="{ active: $route.query.goodstype == '0' }">
        <div
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '0' } })
              .catch(() => {})
          "
        >
          전체
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == '1' }">
        <div
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '1' } })
              .catch(() => {})
          "
        >
          드라이버
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == '2' }">
        <div
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '2' } })
              .catch(() => {})
          "
        >
          우드
        </div>
      </swiper-slide>

      <swiper-slide :class="{ active: $route.query.goodstype == '3' }">
        <div
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '3' } })
              .catch(() => {})
          "
        >
          유틸리티
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == '4' }">
        <div
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '4' } })
              .catch(() => {})
          "
        >
          아이언
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == '5' }">
        <div
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '5' } })
              .catch(() => {})
          "
        >
          웨지
        </div>
      </swiper-slide>

      <swiper-slide :class="{ active: $route.query.goodstype == '6' }">
        <div
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '6' } })
              .catch(() => {})
          "
        >
          퍼터
        </div>
      </swiper-slide>
    </swiper>
    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-1-tab"
          type="button"
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '0' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.goodstype == '0' }"
        >
          전체
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-2-tab"
          type="button"
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '1' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.goodstype == '1' }"
        >
          드라이버
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '2' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.goodstype == '2' }"
        >
          우드
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '3' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.goodstype == '3' }"
        >
          유틸리티
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '4' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.goodstype == '4' }"
        >
          아이언
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '5' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.goodstype == '5' }"
        >
          웨지
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="
            $router
              .push({ name: 'SaleList', query: { goodstype: '6' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.goodstype == '6' }"
        >
          퍼터
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Tab",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>
